export default __webpack_public_path__ + "static/media/mark_email_read.8a320059.svg";